import "./Title.css";

function Title() {
  return (
    <div className="title">
      <h2>本日のお題はこちら!</h2>
    </div>
  );
}

export default Title;
